import { setState } from './helpers'

const boosterMutations = {
  SET_BOOSTER_FIELDS: setState('boosterFields'),
  SET_BOOSTERS_LIST: setState('boostersList'),
  SET_INACTIVE_BOOSTERS: setState('inactiveBoosters'),
  SET_BOOSTERS_PREVIEW: setState('boostersPreview'),
  SET_USER_BOOSTER_SELECT: setState('userBoosterSelect'),
  SET_BOOSTER_IMPORT_ERRORS: setState('boosterImportErrors'),
  SET_BOOSTER_IMPORT_SUCCESS: setState('boosterImportSuccess'),
  SET_BOOSTER_CCS_DOCUMENTS: setState('boosterCCSDocuments'),
  SET_BOOSTER: setState('booster'),
  SET_BOOSTER_MESSAGE: setState('boosterMessage')
}

export { boosterMutations }
